const utils = require('frontend-controller/lib/utils')

module.exports = {
    model: {
        filterParams: {}
    },

    methods: {
        navToList(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
            if(buttonContext){
                getComponent('mainNav').navToList(buttonContext)
            }
        }
    },

    hooks: {
        updateFilters($element, options){
            this.model.filterParams = this.model.filterParams || {}
            const data = this.model.filterParams
            if(options.filterContext){
                utils.refReplace(data, {
                    [options.filterContext]: options.params || {}
                })
            } else {
                utils.refReplace(data, options.params || {})
            }

            this.triggerClosest('updateFilters', {
                params: data
            })
        }
    }
}